//#### IR NO ARQUIVO TheSiderbar.vue  E CONFIGURAR O MENU PARA CADA PERFIL ####

const Menu = {
  Dashboard: {
    _name: "CSidebarNavItem",
    name: "Dashboard",
    to: "/dashboard",
    icon: "cil-speedometer",
    badge: {
      color: "info-dark"
    }
  },
  Principal: {
    _name: "CSidebarNavTitle",
    _children: ["Principal"]
  },

  Project: {
    _name: "CSidebarNavItem",
    name: "Projeto",
    to: "/projeto",
    icon: "cil-task",
    permission: "Projeto"
  },
  Geolocalizacao: {
    _name: "CSidebarNavItem",
    name: "Geolocalização",
    to: "/geolocalizacao",
    icon: "cil-location-pin",
    permission: "Geolocalizacao"
  },
  Gaau: {
    _name: "CSidebarNavItem",
    name: "GAAU",
    to: "/gaau",
    icon: "cil-layers",
    permission: "Gaau"
  },
  Inventory: {
    _name: "CSidebarNavItem",
    name: "Inventário Florestal",
    to: "/inventario",
    icon: "cil-layers",
    permission: "Inventario"
  },
  Configuracao: {
    _name: "CSidebarNavTitle",
    _children: ["Configurações"]
  },
  Usuarios: {
    _name: "CSidebarNavItem",
    name: "Usuários",
    to: "/usuario",
    icon: "cil-face",
    permission: "Usuario"
  },
  Parametro: {
    _name: "CSidebarNavItem",
    name: "Parâmetros",
    route: "/parametro",
    to: "/parametro",
    icon: "cil-settings",
    permission: "Parametro"
  },
  Transferencia: {
    _name: "CSidebarNavItem",
    name: "Transferência",
    route: "/transferencia",
    to: "/transferencia",
    icon: "cil-file",
    permission: "Transferencia"
  },
  GrupoUsuario: {
    _name: "CSidebarNavItem",
    name: "Grupo Usuário",
    to: "/grupo-usuario",
    icon: "cil-lock-locked",
    permission: "GrupoUsuario"
  },
  Pergunta: {
    _name: "CSidebarNavItem",
    name: "Pergunta",
    to: "/pergunta",
    icon: "cil-layers",
    permission: "Pergunta"
  },
  Carbono: {
    _name: "CSidebarNavItem",
    name: "Banco de dados Arbóreo",
    to: "/densidade-carbono",
    icon: "cil-layers",
    permission: "Carbono"
  },
  EstoqueCarbono: {
    _name: "CSidebarNavItem",
    name: "Estoque Carbono",
    to: "/estoque-carbono",
    icon: "cil-layers",
    permission: "Carbono"
  }
};

export default Menu;
